import { useLocation } from 'react-router-dom';

import EmqHealthBanner from '@/features/dashboard/components/emq-health-banner';
import { GlobalTopBarNotice } from '@/app/shell/global-top-bar-notice';
import { PageTopbarUtilityActions } from '@/components/layout/page-topbar-utility-actions';
import { usePageTopbarAdornmentContext } from '@/contexts/page-topbar-adornment/page-topbar-adornment-context';
import { isStandaloneTitleHidden, resolvePageTitle } from '@/lib/navigation/nav-titles';


interface PageTopbarProps {
  title?: string;
}

const topbarRowClassName =
  'flex items-center px-2 py-0.5 text-foreground sm:px-6 sm:py-1';

export function PageTopbar({ title }: PageTopbarProps) {
  const location = useLocation();
  const { setContainer } = usePageTopbarAdornmentContext();
  const pageTitle = resolvePageTitle(location.pathname, title);
  const hideTitle = isStandaloneTitleHidden(location.pathname);

  return (
    <>
      <GlobalTopBarNotice />
      <EmqHealthBanner />
      {hideTitle ? (
        <div
          className={`${topbarRowClassName} justify-end`}
          data-slot="page-topbar-utility-only"
        >
          <PageTopbarUtilityActions />
        </div>
      ) : (
        <div className={`${topbarRowClassName} justify-between gap-2`}>
          <div className="flex min-w-0 flex-1 items-baseline gap-2">
            <h1 className="mb-0 min-w-0 truncate text-base font-semibold">{pageTitle}</h1>
            {/* Route-owned adornment (keyboard hints, badges), filled by portal. */}
            <span className="shrink-0" data-slot="page-topbar-adornment" ref={setContainer} />
          </div>
          <PageTopbarUtilityActions className="shrink-0" />
        </div>
      )}
    </>
  );
}
